var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('v-fab-transition',[_c('v-btn',{directives:[{name:"show",rawName:"v-show",value:(_vm.scrollTop !== 0),expression:"scrollTop !== 0"}],attrs:{"fixed":"","fab":"","bottom":"","right":""},on:{"click":_vm.backTop}},[_c('v-icon',[_vm._v(" publish ")])],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }